<template>
  <v-menu
    v-if="user && !$store.getters.isAdmin"
    bottom
    min-width="200px"
    rounded
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn icon x-large v-on="on">
        <v-tooltip bottom color="#000">
          <template v-slot:activator="{ on2, attrs2 }">
            <v-avatar color="primary" size="35" v-bind="attrs2" v-on="on2">
              <span class="white--text text-h7">{{ initials }}</span>
            </v-avatar>
          </template>
          <span v-text="'Profile'" />
        </v-tooltip>
      </v-btn>
    </template>
    <v-card>
      <v-list-item-content class="justify-center">
        <div class="px-4 text-center">
          <v-avatar color="primary">
            <span class="white--text text-h5">{{ initials }}</span>
          </v-avatar>
          <h3 v-text="user.fullName" />
          <p class="text-caption mt-1" v-text="user.userName" />

          <v-divider class="my-3"></v-divider>
          <v-btn
            depressed
            block
            text
            :to="{ name: 'Profile' }"
            class="btn-list btn"
          >
            {{ $t("customerProfile.profile") }}
          </v-btn>
          <v-divider class="my-3"></v-divider>
          <v-btn
            depressed
            block
            text
            class="btn-list btn"
            @click.native="logout"
          >
            {{ $t("general.logout") }}
          </v-btn>
        </div>
      </v-list-item-content>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ProfileCustomer",
  computed: {
    ...mapGetters(["user"]),
    initials() {
      if (this.user) {
        return (
          this.user.firstName.slice(0, 1).toUpperCase() +
          this.user.lastName.slice(0, 1).toUpperCase()
        );
      } else {
        return "";
      }
    },
  },
  methods: {
    async logout() {
      this.$store.dispatch("loading/start");
      await this.$store.dispatch("auth/logout");
      this.$store.dispatch("loading/done");
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-list {
  justify-content: start !important;
}
</style>
